import {anyImageOpResult} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {z} from "zod"
import {geometry} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/primitive/rasterize-geometry/definition"
import {dataObjectReference, size2Like} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/basic-definitions"

export const definition = {
    validation: {
        returns: anyImageOpResult,
        parameters: z.object({
            sourceImage: anyImageOpResult,
            gridGeometry: geometry.or(dataObjectReference),
            resultSize: size2Like,
        }),
    },
}
